import Swiper from 'swiper';
import DLAnimate from 'dl-animate/dist/dl-animate-module';

// constants
import { DOCUMENT_ELEMENT } from '@/scripts/constants';

// other
import { leadZero } from '@/scripts/utils';

// assets
import 'swiper/dist/css/swiper.css';
import './swiper-slider-advanced.scss';

export default function initSwiperSlider(props) {
  const {
    container = document,
    slidesPerView = 3,
    spaceBetween = 32,
    breakpoints = null,
    speed = 750,
    selector,
    cropContainer = false,
    pagination = false,
    autoplay = false,
    nested = false,
    loop = false,
    connect = null,
    paginationType = 'fraction',
    loopedSlides = 1,
    swiperTitle = null,
    restOptions = {},
  } = props;
  const sliders = [];
  $(container).find(`[data-slider="${selector}"]`).each((i, el) => {
    const $container = $(el).closest('[data-role*="slider-container"]');
    const $controls = $container.find('.swiper-controls, .swiper-controls_regular, .swiper-controls_separated');
    const $slides = $container.find('.swiper-slide');
    const $pagination = $container.find('.swiper-pagination');
    const $progress = $container.find('[data-role*="progress"]');
    const $line = $progress.find('.line');
    const { seasonFilters } = el.dataset;
    if (!$slides.length) return;
    if (cropContainer) {
      el.classList.add('swiper-container_crop');
    }

    const swiperConfig = {
      preloadImages: false,
      lazy: {
        loadPrevNext: true,
        loadPrevNextAmount: Math.max(1, slidesPerView),
      },
      keyboard: {
        enabled: true,
      },
      slidesPerView,
      spaceBetween,
      breakpoints,
      navigation: {
        nextEl: $controls.find('.swiper-button-next')[0],
        prevEl: $controls.find('.swiper-button-prev')[0],
      },
      pagination: pagination && {
        el: $pagination[0],
        type: paginationType,
        formatFractionCurrent: number => leadZero(number),
        formatFractionTotal: number => leadZero(number),
        renderFraction(currentClass, totalClass) {
          return '<span class="swiper-pagination-title">Page</span>'
            + `<span class="${currentClass}"></span>` +
            `<span class="${totalClass}"></span>`;
        },
        dynamicBullets: true,
        dynamicMainBullets: 3,
        clickable: true,
      },
      parallax: !!el.querySelector('[data-role*="swiper-parallax"]'),
      simulateTouch: false,
      speed,
      autoplay,
      nested,
      loop,
      loopedSlides,
      watchSlidesProgress: true,
      watchSlidesVisibility: true,
      init: false,
      ...restOptions,
    };

    if (swiperTitle) {
      $container.find('[data-role*="swiper-title"]').text(swiperTitle);
    }
    const swiper = new Swiper(el, { ...swiperConfig });
    const $titleContainer = $container.find('[data-role*="slide-title"]');
    const animate = new DLAnimate();

    const waiting = () => {
      $line
        .css({
          'animation-duration': `${autoplay.delay}ms`,
        });
      $progress
        .addClass('is-waiting')
        .removeClass('is-sliding');
    };
    const sliding = (activeIndex, slidersCount) => {
      $line
        .css({
          'transiton-duration': `${speed}ms`,
          transform: `scaleX(${activeIndex / (slidersCount - 1)})`,
          // width: `${Math.ceil(activeIndex * 100 / (slidersCount - 1))}%`,
        });
    };

    waiting();
    swiper
      .on('init', () => {
        const { title } = $slides[swiper.activeIndex].dataset;
        if (title) {
          $container.find('[data-role*="slide-title"]').text(title);
        }
      })
      .on('transitionStart', () => {
        const { title } = $slides[swiper.activeIndex].dataset;
        if (title) {
          animate.hide($titleContainer[0], {
            name: 'slide-title',
            afterLeave() {
              $titleContainer.text(title);
              animate.show($titleContainer[0], {
                name: 'slide-title',
              });
            },
          });
        }
        $slides.addClass('is-animated');
        if (pagination) {
          sliding(swiper.activeIndex, $slides.length);
        }
      })
      .on('transitionEnd', () => {
        $slides.removeClass('is-animated');
        if (pagination) {
          waiting();
        }
      });

    swiper.init();
    swiper.lazy.loadInSlide(0);

    if (connect) {
      const [connectedSlider] = initSwiperSlider({
        ...swiperConfig,
        selector: connect,
        connect: null,
      });
      connectedSlider.controller.control = swiper;
      swiper.controller.control = connectedSlider;
    }
    if (seasonFilters) {
      const $shadowSlides = $slides.map((index, slide) => slide);
      const $wrapper = $(el).find('.swiper-wrapper');
      DOCUMENT_ELEMENT.addEventListener('filterseason', ({ detail }) => {
        $wrapper.children().remove();
        $wrapper.append($shadowSlides.filter((index, slide) => slide.dataset.season === detail.season));
        swiper.update();
      });
    }

    sliders.push(swiper);
  });
  return sliders;
}



// WEBPACK FOOTER //
// ./components/swiper-slider-adanced/swiper-slider-advanced.js